var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","md5":"","offset-md2":""}},[_c('h1',{staticClass:"text-xs-center"},[_vm._v("This is an about page")])])
}
var staticRenderFns = []

export { render, staticRenderFns }